import styles from './TextInput.module.scss';
import {
  type ReactNode,
  type FocusEvent,
  type KeyboardEvent,
  Ref,
  useRef,
  ChangeEvent,
  useContext,
  useEffect,
} from 'react';
import { useMergeRefs } from '@libs/react/ref';
import { FormContext } from '../form/FormContext';
import { FormFieldContext } from '../form/FormFieldContext';
import clsx from 'clsx';
import { FormFieldInputContext } from '../form/FormField';
import { InputStatus } from './InputStatus';
import { TextInputShared, TextInputType } from './TextInputShared';
import { InputAlign } from './InputContainer';

interface Props {
  align?: InputAlign;
  bottom?: ReactNode;
  defaultValue?: string;
  disabled?: boolean;
  end?: ReactNode;
  id?: string;
  label: string;
  max?: number;
  maxLength?: number;
  min?: number;
  name?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onValue?: (value: string) => void;
  prefix?: string;
  preventNewline?: undefined;
  ref?: Ref<HTMLInputElement>;
  required?: boolean;
  status?: InputStatus;
  step?: number;
  suffix?: string;
  type?: TextInputType;
  value?: string;
}

export function TextInput(props: Props) {
  const { end, ...rest } = props;

  return (
    <TextInputShared
      {...rest}
      ref={props.ref}
      addon={end}
      label={props.label}
      name={props.name}
      type={props.type}
    />
  );
}
